import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch, Emit } from 'vue-property-decorator';
import REQ_URL from '@/consts/req-url';
import { Categories, CategoriesFlat } from '@/types/categories';
import CategoryTree from '../CategoryTree/CategoryTree';
import { FilterParams } from '@/types/filter';
import { getCategories } from '@/api/categories';

@Component({
    components: {
        CategoryTree
    },
    model: {
        prop: 'isShowDrawer',
        event: 'show'
    },
})
export default class ProductFilterPanel extends Vue {
    @Prop({ default: false }) isShowDrawer!: Boolean
    @Prop({
        default: () => {
            let def: FilterParams = {
                brand: '',
                spec: '',
                search: ''
            }
            return def
        }
    }) initialFilterParams!: FilterParams
    get showDrawer() {
        return this.isShowDrawer
    }
    set showDrawer(val) {
        this.$emit('show', val)
    }

    timerId: number | null = null
    timerDelay = 500

    categories: Categories = []
    flatCategories: CategoriesFlat = []

    /// [category id] or []
    selectedCat: string[] = this.initialFilterParams.categoryId ? [this.initialFilterParams.categoryId] : []
    selectedBrand: string = this.initialFilterParams.brand
    selectedSpecial: string = this.initialFilterParams.spec
    search: string = this.initialFilterParams.search

    ///
    selectedCatMobile = this.selectedCat
    selectedBrandMobile: string = this.initialFilterParams.brand
    selectedSpecialMobile: string = this.initialFilterParams.spec
    searchMobile: string = this.initialFilterParams.search

    treeDialog = false
    brands = [
        'Все',
        'Hardax',
        'RemoColor',
        'Hobbi',
        'Yard',
        'Остальные'
    ]
    spec = [
        'novelties',
        'hits',
        'sell-out'
    ]
    @Watch('initialFilterParams') onInitialFilterParamsChange() {
        this.selectedCat = this.selectedCatMobile = this.initialFilterParams.categoryId ? [this.initialFilterParams.categoryId] : []
        this.selectedBrand = this.selectedBrandMobile = this.initialFilterParams.brand
        this.selectedSpecial = this.selectedSpecialMobile = this.initialFilterParams.spec
        this.search = this.searchMobile = this.initialFilterParams.search
    }
    // Autocomplete items get the menu list as `parent`: it filters (noFilter
    // off) only while the visitor is searching
    isSearchingCategory(data: { parent: { noFilter: boolean } }) {
        return !data.parent.noFilter
    }
    // Indented by level, flat while searching
    categoryItemStyle(data: { item: { depth: number }, parent: { noFilter: boolean } }) {
        return { paddingLeft: `${this.isSearchingCategory(data) ? 0 : data.item.depth * 16}px` }
    }
    async setCat() {
        let { fullCategories, flatCategories } = await getCategories()
        this.categories = fullCategories
        this.flatCategories = flatCategories
    }
    async setBrands() {
        try {
            let data = await this.$fetch<string[]>(REQ_URL.GET_BRANDS);
            if (data.body) {
                this.brands = data.body
            }
        } catch (error) {
        }
    }
    @Emit('show')
    closeDrawer() {
        return false
    }
    @Emit('filter')
    emitFilterChanges() {
        return new Promise((res, rej) => {
            setTimeout(() => {
                let filterParams: FilterParams = {
                    // The mobile autocomplete leaves [null] after clearing
                    categoryId: this.selectedCat[0] || undefined,
                    brand: this.selectedBrand,
                    spec: this.selectedSpecial,
                    search: this.search
                }
                res(filterParams)
            }, 100)
        })
    }

    applyMobileFilter() {
        this.selectedCat = this.selectedCatMobile
        this.selectedBrand = this.selectedBrandMobile ? this.selectedBrandMobile : ''
        this.selectedSpecial = this.selectedSpecialMobile ? this.selectedSpecialMobile : ''
        this.search = this.searchMobile ? this.searchMobile : ''
        this.emitFilterChanges()
    }
    resetFilterMobile() {
        this.selectedCatMobile = this.selectedCat = []
        this.selectedBrandMobile = this.selectedBrand = ''
        this.selectedSpecialMobile = this.selectedSpecial = ''
        this.searchMobile = this.search = ''
    }
    throtleFilterChanges() {
        if (this.timerId !== null) clearTimeout(this.timerId)
        this.timerId = setTimeout(() => {
            this.emitFilterChanges()
        }, this.timerDelay);
    }
    onEnter(e: KeyboardEvent) {
        e.preventDefault();
        this.emitFilterChanges();
    } 
    async created() {
        this.setCat()
        this.setBrands()
    }
}